import React from "react";

import styled from "styled-components";



const CardWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: #dedede;
  //border-radius: 10px;
  padding: 5px;
  width: 200px;
  height: 200px;
  border: 1px solid #1d1d1d;
  align-items: center;
  justify-content: center;

  background-color: #1d1d1d;
  padding: 10px;
  border: 1px white solid;
  color: white;

  :hover {
    background-color: #3d3d3d;
  }
`;

const CardTitle = styled.div`
  display: flex;
  justify-content: center;
  font-weight: 400;
`;

const CardBody = styled.div`
  display: grid;
  grid-template-columns: 80px 80px;
  grid-template-rows: 70px 70px;
  height: 100%;
  grid-gap: 3px;
`;

const CardImageTile = styled.div`
  height: 100%;
  width: 100%;
  //background-color: red;
  border: 1px solid white;
  //margin: 2px 2px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.9em;
  background-color: #5d5d5d;
`;

const PreviewImage = styled.img`
  display: block;
  object-fit: cover;
  height: 100%;
  width: 100%;
  //max-height: 100%;
  //max-width: 100%;
  //min-height: 100%;
  //min-width: 50%;
`;

const Card = ({ title, previewImages, totalImages, onClick }) => (
  <CardWrapper onClick={onClick}>
    <CardTitle>{title}</CardTitle>
    <CardBody>
      {previewImages &&
        previewImages.map((image, index) => (
          <CardImageTile>
            {<PreviewImage src={image.src} srcSet={image.srcSet} key={index} />}
          </CardImageTile>
        ))}
      {totalImages > 0 && <CardImageTile>+{totalImages}</CardImageTile>}
    </CardBody>
  </CardWrapper>
);

const CenterWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
const MenuContainer = styled.div`
  display: grid;
  grid-template-columns: 200px 200px 200px;
  @media only screen and (max-width: 480px) {
    grid-template-columns: 200px 200px;
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 480px) {
    grid-template-columns: 200px 200px;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    grid-template-columns: 200px 200px 200px;
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    grid-template-columns: 200px 200px 200px;
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    grid-template-columns: 200px 200px 200px;
  }
`;

const Menu = ({ items, collectionClicked }) => (
  <CenterWrapper>
    <MenuContainer>
      {items &&
        items.map((item) => (
          <Card
            key={item.title}
            title={item.title}
            previewImages={item.images.slice(0, 3)}
            totalImages={item.images.length - 3}
            onClick={() => collectionClicked && collectionClicked(item)}
          />
        ))}
    </MenuContainer>
  </CenterWrapper>
);

export default Menu;
